<template>
  <div class="instruction">
    <div class="upgrade">
      <div class="title">升级条件</div>
      <div class="item" v-for="(item, index) in upgrade" :key="index">{{item}}</div>
    </div>
    <div class="rights">
      <div class="title">会员福利</div>
      <div v-for="(item , index) in rights" :key="index" class="item">
        {{ item }}
      </div>
    </div>
    <div class="buy">
      <div class="title">支持购买</div>
      <div class="item" v-for="(item, index) in buy" :key="index">{{item}}</div>
    </div>
    <div class="refund">
      <div class="title">支持退卡</div>
      <div class="item" v-for="(item, index) in refund" :key="index">{{item}}</div>
    </div>
    <div class="notes">
      <div class="title">注意事项</div>
      <div class="item" v-for="(item, index) in notes" :key="index">{{item}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        "upgrade": [
          "获得10000活跃经验值，将立即升级为黄金会员。",
          "自然升级用户在经验值满足条件后立即升级,每个月1号将根据最近12个月内的活跃经验值重新评定(赠送或购买用户等级调整以展示的有效期为准)",
          "黄金会员期间随时通过购票或购买行为升级为更高等会员。"
        ],
        "rights": [
          "生日礼物：设置生日后，还将在生日当天获得价值29元生日礼包一份（以生日当天的等级为准，1年内只发放一次）。",
          "抢票提速：黄金用户享受抢票1.5倍加速，抢票更容易。",
          "酒店会员价：黄金用户还享受部分酒店最高9.4折优惠",
          "提速宝：每月1日将自动发放提速宝10个（可用于抢票时抵扣套餐费用）。",
          "延误宝：每月1日将自动发放延误宝2个（列车延误半小时奖励5元，1小时奖励10元）。"
        ],
        "buy": [
          "为了让更多的用户可以直接享受高等级权益，高铁管家白金会员支持直接购买升级，黄金会员售价为49元/年。",
          "购买黄金会员的用户可以选择常旅客礼包或抢票礼包任意一个，选择常旅客礼包的用户：跟本人（需绑定身份证）购票时可享受：购买火车票首单立返15元（出票成功后返现），并在有效期内享受每单返现5元优惠（火车票价格>=10，每月最多享受5次，列车到站后24小时内返现；特别提醒：火车票改签或退票后将不再返现）有效期内总返现次数8次（不含首次），最终可得55元。返现金额将充值到您的管家余额（可提现到支付宝）可用于app内任何消费，支付时选择余额支付即可。",
          "有效期内如已全部返现，可以购买更高等级的会员，继续享受常旅客超值返现服务。暂不支持重复购买。",
          "选择抢票礼包的用户，送顶级抢票券5张，价值200元；5次优先出票权，价值100元。",
          "购买成功后立即生效，有效期1年，且1年内不允许重复购买，权益一经使用，不支持退款。",
          "有效期内如将顶级抢票券全部使用，可以购买更高等级的会员或购买高铁抢票卡，继续享受低价高抢票速度的服务。"
        ],
        "refund": [
          "特别提醒：如您已使用过或正在使用当前会员权益（如首单立返，单单返现，抢票券，优惠券，提速宝，延误宝，生日礼物等）将无法退订",
          "退订后，将根据您的活跃经验值（最近12个月内经验值）重新调整会员等级，并享受对应的权益和福利",
          "确认退会员以后，我们将在1-5个工作日内为您退款，退款将原路退回您的付款账户上",
          "购买会员生效起计算，30天后将在会员详情页展示申请退会员入口，可在线申请退款。"
        ],
        "notes": [
          "会员用户在使用会员服务的过程中，要严格遵守法律法规，不得利用漏洞，技术手段等牟取不当得利，一经发现，高铁管家有权取消该用户会员资格，且需要承担法律责任。",
          "在法律许可的范围内，高铁管家将根据需要对会员规则做调整包括升级条件及权益内容，如有重大调整，将通过push，短信或微信公众号等方式及时通知您。"
        ]

      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "@/scss/_vars.scss";
  @import "./style/common.scss";
  .instruction {
    min-height: 100%;
    overflow: hidden;
    .upgrade,
    .rights,
    .buy,
    .refund,
    .notes {
      margin-top: 20*$px;
      .title {
        font-size: 18*$px;
        margin-left: 25*$px;
        position: relative;
        &::before {
          display: block;
          content: '';
          width: 8*$px;
          height: 8*$px;
          background-color: orange;
          position: absolute;
          top: 50%;
          left: -15*$px;
          // transform: translateY(-50%);
          transform-origin: center center;
          transform: translateY(-50%) rotateZ(-45deg);
        }
      }
      .item {
        font-size: 16*$px;
        margin: 10*$px;
        margin-left: 30*$px;
        color: #666;
        position: relative;
        &::before {
          display: block;
          content: '';
          width: 3*$px;
          height: 3*$px;
          background-color: #666;
          border-radius: 50%;
          position: absolute;
          top: 10*$px;
          left: -10*$px;
          transform: translateY(-50%);

        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldSale/instruction.vue